import React, { Component } from 'react'  
import Chart from "react-google-charts";
export class DeathLineChart extends Component {  
        constructor() {  
                super();  
                this.state = { Data: {} ,
                chartData : [],
        };  
        }  
        componentDidMount() {               
                const columns = [
                        { type: 'string', label: 'Date' },
                        { type: 'number', label: 'Cases' },
                      ]                  
              Promise.all([
                fetch('https://api.covid19india.org/data.json'),
            ]) 
            .then(([res1]) => Promise.all([res1.json()]))       
                                    .then(([data]) => {  
                                            const state = data; 
                                            let rows = [];                                  
                                            state['cases_time_series'].forEach(record => {  
                                                rows.push([record.date, record.totaldeceased])
                                         });  

                                         
                                this.setState({  
                                        chartData: [columns, ...rows],
                                });  
                  
                            })
        }  

        render() {  

                return (  
                        <div class="chartBox" style={{border:'solid  grey', borderRadius:'5px',background:'#001b35'}}>  
                        <b><center style={{color:"grey"}}>DEATHS</center></b> 
                        {this.state.chartData != undefined && this.state.chartData.length > 0?
                        <Chart
                            height={250}
                            chartType="LineChart"
                            loader={<div style={{color:'grey'}}><center>Loading Chart</center></div>}
                            data={this.state.chartData}
                        
                            options={{
                            legend: 'none',
                            colors:['grey'],
                            backgroundColor: '#001b35',
                        //       title: 'DEATHS',
                            curveType: 'function',
                            width: '100%',
                            height: '100%',
                            chartArea: {
                                height: "50%",
                                width: "75%"
                                },
                            
                            hAxis: {
                                title: '',  textStyle: {
                                    fontSize: 10,
                                    bold: true,
                                    color: '#848484'
                                },
                                gridlines: {
                                        color: 'transparent'
                                    },
                        //    textPosition: 'none'
                            },
                            vAxis: {
                                viewWindow: {
                                    min: 0
                                },
                                title: 'Cases',
                                textStyle: {
                                    fontSize: 12,
                                    bold: true,
                                    color: '#848484'
                                },
                                titleTextStyle: {
                                    fontSize: 12,
                                    bold: true,
                                    color: '#848484'
                                },
                                gridlines: {
                                        color: 'transparent'
                                    },
                            },
                        //       backgroundColor: { fill: "#F4F4F4" } 
                            }}
                        />
                        :
                        <center><p class="LoaderMsg">Please wait, Loading............</p></center>    
                        }

                        </div>  

                )  

        }  

}  

export default DeathLineChart 